import { executeRequest, Request } from '@jfs/network'
import { getAPIURL, getPaymentHeader } from '../config'

/**
 * New PG
 * Will return the card schema and type
 * @param params
 */
const binService = (params: any) => {
  const URL = getAPIURL('binService')
  const request: Request<{}> = {
    apiPath: URL,
    method: 'POST',
    headers: getPaymentHeader(),
    body: params,
  }
  return executeRequest(request)
    .then((response) => {
      const { data } = response
      return data
    })
    .catch((err) => {
      const {
        data: { error },
      } = err
      throw error
    })
}

export { binService }
